"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.device = exports.size = void 0;
var size = {
  mobileS: 320 + 1,
  mobileM: 375 + 1,
  mobileL: 425 + 1,
  tablet: 768 + 1,
  laptop: 1024 + 1,
  laptopL: 1440 + 1,
  desktop: 2560 + 1
};
exports.size = size;
var device = {
  mobileS: "(max-width: ".concat(size.mobileS, "px)"),
  // 320px
  mobileM: "(max-width: ".concat(size.mobileM, "px)"),
  // 375px
  mobileL: "(max-width: ".concat(size.mobileL, "px)"),
  // 425px
  tablet: "(max-width: ".concat(size.tablet, "px)"),
  // 768px
  laptop: "(max-width: ".concat(size.laptop, "px)"),
  // 1024px
  laptopL: "(max-width: ".concat(size.laptopL, "px)"),
  // 1440px
  desktop: "(max-width: ".concat(size.desktop, "px)") // 2560px
  // laptop: `(max-width: ${size.laptop - shopifyMenuWidth}px)`, // 784px
  // laptopL: `(max-width: ${size.laptopL - shopifyMenuWidth}px)`, // 1200px
  // desktop: `(max-width: ${size.desktop - shopifyMenuWidth}px)`, // 2320px

};
exports.device = device;